const BIRTH_YEAR_MIN = "BIRTH_YEAR_MIN";
const BIRTH_YEAR_MAX = "BIRTH_YEAR_MAX";
const BIRTH_DATE_GAP = "BIRTH_DATE_GAP";
const GENDER = "GENDER";
const RACE = "RACE";

export const SETTINGS_CONFIG = {
  BIRTH_YEAR_MIN,
  BIRTH_YEAR_MAX,
  BIRTH_DATE_GAP,
  GENDER,
  RACE,
} as const;
